import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const API_BASE = process.env.REACT_APP_API_URL || '';

export default function ReportsPage() {
  const [summary, setSummary] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('');

  useEffect(() => {
    api.get('/admin/reports/summary')
      .then(setSummary)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const getToken = () => localStorage.getItem('token') || '';

  const download = (endpoint: string, filename: string) => {
    const params = period ? `?period=${period}` : '';
    const url = `${API_BASE}/admin/reports/${endpoint}${params}`;
    fetch(url, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then(res => res.blob())
      .then(blob => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
      })
      .catch(() => alert('Татах боломжгүй'));
  };

  const periods = Array.from({ length: 12 }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - i);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  });

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#5f6f66' }}>Ачаалж байна...</div>;

  return (
    <div>
      <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 24, color: '#1c2b22', marginBottom: 24 }}>
        Тайлан & Экспорт
      </h2>

      {/* Summary */}
      {summary && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 32 }}>
          <SummaryCard label="Нийт нэхэмжлэх" value={String(summary.total_invoices)} icon="receipt" color="#236844" />
          <SummaryCard label="Нийт төлбөр" value={String(summary.total_payments)} icon="payment" color="#2f7d52" />
          <SummaryCard label="Идэвхтэй өр" value={String(summary.active_debts)} icon="debt" color="#ef4444" />
          <SummaryCard label="Нийт оршин суугч" value={String(summary.total_residents)} icon="people" color="#3b82f6" />
        </div>
      )}

      {/* Period Filter */}
      <div style={{ ...card, marginBottom: 20, display: 'flex', alignItems: 'center', gap: 16 }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#2a3b32' }}>Тайлант хугацаа:</label>
        <select value={period} onChange={e => setPeriod(e.target.value)} style={selectStyle}>
          <option value="">Бүгд</option>
          {periods.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>

      {/* Export Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <ExportCard
          title="Нэхэмжлэхийн тайлан"
          description="Бүх нэхэмжлэхийн мэдээлэл: сар, орон сууц, дүн, төлөв, хугацаа"
          icon="📊"
          onExport={() => download('invoices', `invoices_${period || 'all'}.csv`)}
        />
        <ExportCard
          title="Төлбөрийн тайлан"
          description="Бүх төлбөрийн мэдээлэл: огноо, арга, дүн, төлөв"
          icon="💳"
          onExport={() => download('payments', `payments_${period || 'all'}.csv`)}
        />
        <ExportCard
          title="Өрийн тайлан"
          description="Идэвхтэй өрийн жагсаалт: орон сууц, дүн, хэтэрсэн хоног"
          icon="📋"
          onExport={() => download('debts', 'debts.csv')}
        />
        <ExportCard
          title="Оршин суугчдын жагсаалт"
          description="Бүх оршин суугчид: орон сууц, нэр, утас, хэрэглэгчийн төрөл"
          icon="👥"
          onExport={() => download('residents', 'residents.csv')}
        />
      </div>
    </div>
  );
}

function SummaryCard({ label, value, icon, color }: { label: string; value: string; icon: string; color: string }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 12, padding: 20,
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)', borderLeft: `4px solid ${color}`,
    }}>
      <div style={{ fontSize: 13, color: '#5f6f66', marginBottom: 8 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: '#1c2b22', fontFamily: "'Inter'" }}>{value}</div>
    </div>
  );
}

function ExportCard({ title, description, icon, onExport }: {
  title: string; description: string; icon: string; onExport: () => void;
}) {
  return (
    <div style={{
      background: '#fff', borderRadius: 12, padding: 24,
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      display: 'flex', alignItems: 'center', gap: 20,
    }}>
      <div style={{
        width: 56, height: 56, borderRadius: 12,
        background: '#f0f9f4', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 28, flexShrink: 0,
      }}>
        {icon}
      </div>
      <div style={{ flex: 1 }}>
        <h3 style={{ fontFamily: "'Inter'", fontWeight: 600, fontSize: 16, color: '#1c2b22', margin: '0 0 4px' }}>{title}</h3>
        <p style={{ fontSize: 13, color: '#5f6f66', margin: 0 }}>{description}</p>
      </div>
      <button onClick={onExport} style={{
        background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none',
        padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14,
        fontFamily: "'Inter'", whiteSpace: 'nowrap', flexShrink: 0,
      }}>
        CSV татах
      </button>
    </div>
  );
}

const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const selectStyle: React.CSSProperties = {
  padding: '8px 14px', border: '1.5px solid #dcdacf', borderRadius: 10,
  fontSize: 14, background: '#fbfaf6', minWidth: 150,
};
